
import React from 'react';
import { Chart } from 'react-google-charts';


function CropCharacterization() {
    const data = [
        [
            'Month',
            'Line 1',
            { role: 'interval' },
            { role: 'interval' },
            'Line 2',
            { role: 'interval' },
            { role: 'interval' },
            'Line 3',
            { role: 'interval' },
            { role: 'interval' },
        ],
        ['Jan', 0.1, 0.08, 0.12, 0.4, 0.35, 0.45, 0.3, 0.25, 0.35],
        ['Feb', 0.15, 0.12, 0.18, 0.5, 0.45, 0.55, 0.35, 0.3, 0.4],
        ['Mar', 0.2, 0.18, 0.22, 0.6, 0.55, 0.65, 0.4, 0.35, 0.45],
        ['Apr', 0.25, 0.22, 0.28, 0.7, 0.65, 0.75, 0.45, 0.4, 0.5],
        ['May', 0.3, 0.28, 0.32, 0.75, 0.7, 0.8, 0.5, 0.45, 0.55],
        ['Jun', 0.35, 0.32, 0.38, 0.8, 0.75, 0.85, 0.55, 0.5, 0.6],
        ['Jul', 0.4, 0.38, 0.42, 0.75, 0.7, 0.8, 0.6, 0.55, 0.65],
        ['Aug', 0.45, 0.42, 0.48, 0.7, 0.65, 0.75, 0.65, 0.6, 0.7],
        ['Sep', 0.5, 0.48, 0.52, 0.65, 0.6, 0.7, 0.7, 0.65, 0.75],
        ['Oct', 0.55, 0.52, 0.58, 0.6, 0.55, 0.65, 0.75, 0.7, 0.8],
        ['Nov', 0.6, 0.58, 0.62, 0.55, 0.5, 0.6, 0.8, 0.75, 0.85],
        ['Dec', 0.65, 0.62, 0.68, 0.5, 0.45, 0.55, 0.75, 0.7, 0.8],
    ];
    
    
    const options = {
        title: 'Crop Characterization',
        curveType: "function",
        legend: { position: "bottom" },
        hAxis: {
            title: 'Month',
            format: 'MMM yyyy',
        },
        vAxis: {
            title: 'Values',
            minValue: 0.1,
            maxValue: 0.8,
        },
        intervals: {
            style: 'area',
            color: '#e5e5e5',
            areaOpacity: 0.2,
        },
        series: {
            0: { color: '#e2431e' },
            1: { color: '#6f9654' },
            2: { color: '#1c91c0' },
        },
        pointSize: 5,
    };
    

    return (
        <div style={{ width: '100%' }}>
            <Chart
                chartType="LineChart"
                width="100%"
                height="400px"
                data={data}
                options={options}
            />        
        </div>
    );
}

export default CropCharacterization;